import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';

import { MDText } from 'i18n-react';

import { toast } from '@motorway/mw-highway-code/pre-alpha';

import { UserContext } from 'Context/user';

import { useFeatureFlags } from 'Utilities/hooks';
import { useNetworkStatus } from 'Utilities/user/hooks/useNetworkStatus';
import { useSetRefreshToken } from 'Utilities/user/hooks/useSetRefreshToken';
import { useVisibilityStatus } from 'Utilities/user/hooks/useVisibilityStatus';

import texts from '../../../../texts.json';

const LocalT = new MDText(texts);

export const useCognito = () => {
  const { userState: user } = useContext(UserContext);

  const history = useHistory();

  const { useAuthnIdToken } = useFeatureFlags();
  const { setCognitoIdTokenRefreshInterval, stopRefreshInterval, triggerRefreshInterval } = useSetRefreshToken();
  const { cleanupNetworkListeners, setupNetworkListeners } = useNetworkStatus({
    handleOffline: stopRefreshInterval,
    handleOnline: triggerRefreshInterval,
  });
  const { cleanupVisibilityListeners, setupVisibilityListeners } = useVisibilityStatus({
    handleOffVisibility: stopRefreshInterval,
    handleOnVisibility: triggerRefreshInterval,
  });

  useEffect(() => {
    const params = Object.fromEntries(new URLSearchParams(history.location.search));

    if (params?.logout === 'notify') {
      toast({
        content: LocalT.translate('components.userSession.error.content'),
        heading: LocalT.translate('components.userSession.error.title'),
        id: 'logout-notification',
        variant: 'error',
      });
      history.replace({
        search: '',
      });
    }
  }, [history]);

  useEffect(() => {
    if (useAuthnIdToken && Number.isInteger(user?.id) && user?.cognitoTokens?.refreshToken) {
      setCognitoIdTokenRefreshInterval(false);
    }
  }, [useAuthnIdToken, user?.id, user?.cognitoTokens?.refreshToken, setCognitoIdTokenRefreshInterval]);

  useEffect(() => {
    if (useAuthnIdToken && Number.isInteger(user?.id) && user?.cognitoTokens?.refreshToken) {
      setupNetworkListeners();
      setupVisibilityListeners();
    }
    return () => {
      cleanupNetworkListeners();
      cleanupVisibilityListeners();
    };
  }, []);
};
